// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1___6e6db606af6fd7aef83{/*!*/}.ToolsMenu-cls2___cf4911e0474f63aca70{margin:0px 12px;font-family:Roboto;font-size:14px;font-style:normal;font-weight:400;line-height:18px;color:#888}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1___6e6db606af6fd7aef83",
	"cls2": "ToolsMenu-cls2___cf4911e0474f63aca70 ToolsMenu-cls1___6e6db606af6fd7aef83"
};
export default ___CSS_LOADER_EXPORT___;
